import React from "react";
import { createPortal } from "react-dom";
 
export default function Toast({
  open,
  message,
  onClose,
}) {
  if (!open) return null;
 
  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center pointer-events-none px-6">
      <div className="pointer-events-auto flex items-center gap-3 rounded-lg bg-white px-4 py-3 text-sm text-gray-900 shadow-xl border max-w-[85%]">
        <span className="text-center">{message}</span>
 
        <button
          type="button"
          className="ml-1 text-gray-400 hover:text-gray-700"
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>
      </div>
    </div>,
    document.body
  );
}